import Logo from '@liveauctioneers/caterwaul-components/lib/Assets/Logo';
import Link from '@liveauctioneers/caterwaul-components/lib/Link/Link';
import * as React from 'react';
import styled from 'styled-components';

import LiveAuctionSettingsMenu from '@/pages/BiddingConsole/components/LiveAuctionSettingsMenu/LiveAuctionSettingsMenu';
import { useAppSelector } from '@/redux/hooks';
import {
    getCatalogSellerId,
    getCatalogSellerName,
    getCatalogTitle,
} from '@/redux/modules/catalog/catalogs/catalog.selectors';
import { getCatalogUrl, getHomeUrl, getSellerUrl } from '@/utils/urls';

type Props = {
    catalogId: number;
    onCurrencyChanged: (value) => void;
    selectedCurrency: string;
};

const AuctionNameAndSettingsBlock = ({ catalogId, onCurrencyChanged, selectedCurrency }: Props) => {
    const catalogTitle = useAppSelector((state) => getCatalogTitle(state, catalogId));
    const catalogSellerName = useAppSelector((state) => getCatalogSellerName(state, catalogId));
    const sellerId = useAppSelector((state) => getCatalogSellerId(state, catalogId));
    const catalogUrl = useAppSelector(() => getCatalogUrl(catalogId, catalogTitle));
    const sellerUrl = useAppSelector(() => getSellerUrl(sellerId, catalogSellerName));

    return (
        <Container>
            <LogoAndSettingsContainer>
                <Link
                    route={false}
                    target="_blank"
                    to={getHomeUrl()}
                >
                    <Logo
                        height="24px"
                        width="179px"
                    />
                </Link>
                <LiveAuctionSettingsMenu
                    catalogId={catalogId}
                    onCurrencyChanged={onCurrencyChanged}
                    selectedCurrency={selectedCurrency}
                />
            </LogoAndSettingsContainer>
            <Link
                primary
                route={false}
                target="_blank"
                to={catalogUrl}
            >
                {catalogTitle}
            </Link>
            <br />
            <Link
                primary
                route={false}
                target="_blank"
                to={sellerUrl}
            >
                {catalogSellerName}
            </Link>
        </Container>
    );
};

export default AuctionNameAndSettingsBlock;

const Container = styled.div`
    background: ${({ theme }) => theme.colors.white};
    padding: 24px;
    margin-bottom: 16px;
    border: 1px solid ${({ theme }) => theme.colors.grey400};
`;

const LogoAndSettingsContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
`;
